import React from 'react';
import { useNavigate } from 'react-router-dom';
import './topbar.css';
import logoutIcon from '../assets/logout.svg';
import searchIcon from '../assets/search.svg';
import { supabase } from '../supabase';

const Topbar = ({ toggleSidebar }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/', { replace: true });
  };

  return (
    <header className="topbar">
      <button
        aria-label="Open sidebar"
        className="topbar_burger"
        onClick={toggleSidebar}
        type="button"
      >
        <span />
        <span />
        <span />
      </button>

      <label className="topbar_search" htmlFor="topbar-search" role="search">
        <img alt="" src={searchIcon} />
        <input
          aria-label="Search dashboard"
          id="topbar-search"
          placeholder="Search..."
          type="search"
        />
      </label>

      <div className="topbar_actions">
        <div className="topbar_user">
          <div className="topbar_avatar">Z</div>
          <div className="topbar_user_text">
            <div className="topbar_user_name">Zeina Tamer</div>
            <div className="topbar_user_role">Admin</div>
          </div>
        </div>

        <button
          aria-label="Log out"
          className="topbar_icon_button"
          onClick={handleLogout}
          type="button"
        >
          <img alt="" src={logoutIcon} />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
